import service from "@irati-tracking/tracker"

const CULTURE_HUB_TRACKING_ROOT = "culture_hub"

const tracking = {
  cultureHubHasTiles: () => service.trackEvent(`${CULTURE_HUB_TRACKING_ROOT}_has_tiles`, {}),
  cultureHubTileClick: (tileUrl: string) => {
    const data = {
      tileUrl
    }
    service.trackEvent(`${CULTURE_HUB_TRACKING_ROOT}_tile_click`, data)
  }
}

export default tracking
